import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTDropdownFilter from 'general/components/OtherKeenComponents/KTDropdownFilter';
import CustomDateRangePicker, { dateFilter, getDateFilterOption } from 'general/components/Others/CustomDateRangePicker';
import _ from 'lodash';
import PropTypes from 'prop-types';
import UIHelper from 'general/helpers/UIHelper';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import ChargeHelper from 'features/Charge/chargeHelper';
import FleetHelper from 'features/Fleet/fleetHelper';

ChargeDriverListFilterView.propTypes = {
  setFilterDropdown: PropTypes.func,
  filterDropdown: PropTypes.object,
  setFilter: PropTypes.func,
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
};

function ChargeDriverListFilterView({
  setFilterDropdown,
  filterDropdown,
  setFilter,
  onCancel,
  onApply,
  closeDropdown,
}) {
  // MARK: ---- PROPERTIES ----


  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    FleetHelper.Filter.fleetDriverList = filterDropdown;
    setFilter(filterDropdown);
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    const updatedFilter = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      operatorId: '',
      q: '',
      status: '',
      pricingType: '',
      paymentMethod: '',
      workingType: '',
      agencyId: '',
      from: getDateFilterOption(dateFilter.tatCaThoiGian)[0].format('YYYY-MM-DD'),
      to: getDateFilterOption(dateFilter.tatCaThoiGian)[1].format('YYYY-MM-DD'),
      selectedValue: dateFilter.tatCaThoiGian,
    };

    FleetHelper.Filter.fleetDriverList = updatedFilter;
    setFilterDropdown(updatedFilter);
    setFilter(updatedFilter);
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };
  return (
    <div className='pb-4'>
      <div className='row p-4'>
        <div className="col-12 px-4">
          <KTFormSearch
            name="search-bar"
            placeholder="Theo mã tài xế, họ và tên, số điện thoại, email, biển số xe"
            value={filterDropdown.q}
            onSubmit={(text) => {
              const updateFilterDropdown = { ...filterDropdown, q: text };
              setFilterDropdown(updateFilterDropdown);
            }}
          />
        </div>
        {/* Trạng thái */}
        <div className="col-6 pt-2 pr-2">
          <KTDropdownFilter
            label="Trạng thái"
            filterKey="status"
            options={[
              { name: "Tất cả", value: "" },
              ...ChargeHelper.Data.chargeDriverStatusOptions
            ]}
            selectedValue={filterDropdown.status}
            handleChange={(value) => {
              const updateFilterDropdown = { ...filterDropdown, status: value };
              setFilterDropdown(updateFilterDropdown);
            }}
          />
        </div>
        {/* Loại giá sạc */}
        <div className="col-6 pt-2 pl-2">
          <KTDropdownFilter
            label="Loại giá sạc"
            filterKey="chargeType"
            options={[
              { name: 'Tất cả', value: '' },
              ...FleetHelper.Data.pricingTypeOptions
            ]}
            selectedValue={filterDropdown.chargeType}
            handleChange={(value) => {
              const updateFilterDropdown = { ...filterDropdown, chargeType: value };
              setFilterDropdown(updateFilterDropdown);
            }}
          />
        </div>

        {/* Chính sách thanh toán phí sạc */}
        <div className="col-12">
          <KTDropdownFilter
            label="Chính sách thanh toán phí sạc"
            filterKey="paymentMethod"
            options={[
              { name: 'Tất cả', value: '' },
              ...FleetHelper.Data.paymentMethodOptions
            ]}
            selectedValue={filterDropdown.paymentMethod}
            handleChange={(value) => {
              const updateFilterDropdown = { ...filterDropdown, paymentMethod: value };
              setFilterDropdown(updateFilterDropdown);
            }}
          />
        </div>

        {/* Hình thức làm việc */}
        <div className="col-12">
          <KTDropdownFilter
            label="Hình thức làm việc"
            filterKey="workingType"
            options={[
              { name: 'Tất cả', value: '' },
              ...FleetHelper.Data.workingTypeOptions
            ]}
            selectedValue={filterDropdown.workingType}
            handleChange={(value) => {
              const updateFilterDropdown = { ...filterDropdown, workingType: value };
              setFilterDropdown(updateFilterDropdown);
            }}
          />
        </div>

        <div className='my-2' style={{
          borderTop: `1px dashed ${AppColors.gray[200]}`
        }}></div>

        {/* Khoảng thời gian */}
        <div className="col">
          <label htmlFor="filterByDate" className="mb-0 mr-2 font-weight-bolder">
            Khoảng thời gian
          </label>
          <CustomDateRangePicker
            toggleElementBorderRadius={5}
            alignRight={true}
            initialValue={
              filterDropdown.selectedValue?.length > 0
                ? filterDropdown.selectedValue
                : dateFilter.tatCaThoiGian
            }
            onPressSave={(selectedValue, startDate, endDate) => {
              const updateFilterDropdown = {
                ...filterDropdown,
                selectedValue: selectedValue,
                from: startDate,
                to: endDate,
              };
              setFilterDropdown(updateFilterDropdown);
            }}
          />
        </div>
      </div>
      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Đặt lại mặc định', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeDriverListFilterView;
